const ExpandedReportIcon = ({ size = 18 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12.6732 14.4735V7.3334H5.53809L8.30083 10.0997L7.56527 10.8469L3.52539 6.81058L7.55951 2.77646L8.3102 3.52355L5.53809 6.28413H13.7225V14.4735H12.6732Z"
        fill="#151515"
      />
    </svg>
  );
};

export default ExpandedReportIcon;
